// extracted by mini-css-extract-plugin
module.exports = {"root":"Form__root--Xf4Or","description":"Form__description--2zJzL","multiColumnFormContainer":"Form__multiColumnFormContainer--3S6Rk"};